import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { Box } from '@hover/blueprint';
import Point from './Point';

const WowCustomers = () => {
  const [videoHTML, setVideoHTML] = useState<string>('');

  useEffect(() => {
    const htmlText = `<div class="wistia_responsive_padding" style="padding:66.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_ge7v3c9wbg muted=true playbar=false autoPlay=true endVideoBehavior=loop end" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/ge7v3c9wbg/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" /></div></div></div></div>`;
    setVideoHTML(htmlText);
  }, []);

  const VideoWrapper = styled.div`
    width: 100%;
    max-width: 100%;
    display: block;
  `;
  return (
    <Point
      heading="Wow your customers"
      body="Stand out and build homeowner confidence by answering one of their biggest questions; “What is it going to look like?”"
      image={
        <Box
          width={{ base: '100%', tablet: '540px' }}
          height={{ base: 'auto', tablet: '360px' }}
          borderRadius="12px"
          overflow="hidden"
        >
          <VideoWrapper dangerouslySetInnerHTML={{ __html: videoHTML }} />
        </Box>
      }
    />
  );
};

export default WowCustomers;
